


























import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class AIRouteVisitPlanEditEventDialog extends Vue {
  private isOpen = false;
  private iframeSrc = "";
  private isMounted = false;
  private isPending = false;
  private messageHandler: ((event: MessageEvent) => void) | null = null;
  private tmpScheduleData: { visitScheduleId: number; visitDate: string; officeId: number } | null = null;
  private expectedVisitScheduleId: number | null = null;

  @Emit("saved")
  private emitSaved() {
    return;
  }

  public open(autoRouteUrl: string, visitScheduleId: number, visitDate: string, officeId: number) {
    const params = { visitScheduleId, visitDate, officeId };
    this.expectedVisitScheduleId = visitScheduleId;
    if (!this.isMounted) {
      this.iframeSrc = `${autoRouteUrl}/edit-visit-schedule?office_id=${officeId}&embed=1`;
      this.isMounted = true;
      this.tmpScheduleData = params;
    } else if (this.tmpScheduleData !== null) {
      // AIROUTE_READY待機中、または閉じている間にREADYを見逃した可能性がある。
      // 直接送信も試みる（READY済みなら即処理、未READYなら無視されREADY後に再送）
      this.isPending = true;
      this.tmpScheduleData = params;
      this.sendScheduleUpdate(params);
    } else {
      this.isPending = true;
      this.sendScheduleUpdate(params);
    }
    this.isOpen = true;
    this.setupMessageHandler();
  }

  private sendScheduleUpdate({ visitScheduleId, visitDate, officeId }: { visitScheduleId: number; visitDate: string; officeId: number }) {
    const iframe = this.$refs.iframeEl as HTMLIFrameElement | undefined;
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage(
        { type: "AIROUTE_LOAD_SCHEDULE", visitScheduleId, visitDate, officeId },
        new URL(this.iframeSrc).origin
      );
    }
  }

  private handleClose() {
    this.cleanup();
    this.isOpen = false;
  }

  private resetState() {
    this.cleanup();
    this.isOpen = false;
    this.isMounted = false;
    this.iframeSrc = "";
    this.isPending = false;
    this.tmpScheduleData = null;
    this.expectedVisitScheduleId = null;
  }

  private setupMessageHandler() {
    if (this.messageHandler) {
      window.removeEventListener("message", this.messageHandler);
    }
    this.messageHandler = (event: MessageEvent) => {
      if (!this.isValidOrigin(event.origin)) return;
      const iframe = this.$refs.iframeEl as HTMLIFrameElement | undefined;
      if (iframe && event.source !== iframe.contentWindow) return;
      if (event.data?.type === "AIROUTE_READY" && this.tmpScheduleData) {
        this.sendScheduleUpdate(this.tmpScheduleData);
        this.tmpScheduleData = null;
      } else if (event.data?.type === "AIROUTE_LOAD_SCHEDULE_ACK") {
        if (event.data.visitScheduleId === this.expectedVisitScheduleId) {
          this.isPending = false;
        }
      } else if (event.data?.type === "AIROUTE_EDIT_SCHEDULE_SAVED") {
        this.handleClose();
        this.emitSaved();
      } else if (event.data?.type === "AIROUTE_EDIT_SCHEDULE_CANCELLED") {
        this.handleClose();
      } else if (event.data?.type === "AIROUTE_INIT_ERROR") {
        this.resetState();
      }
    };
    window.addEventListener("message", this.messageHandler);
  }

  private isValidOrigin(origin: string): boolean {
    try {
      const allowedOrigin = new URL(this.iframeSrc).origin;
      return origin === allowedOrigin;
    } catch {
      return false;
    }
  }

  private cleanup() {
    if (this.messageHandler) {
      window.removeEventListener("message", this.messageHandler);
      this.messageHandler = null;
    }
  }

  beforeDestroy() {
    this.cleanup();
  }
}
